module.exports = __webpack_public_path__ + "media/01_パスワードリセット.10bb527a.mp4";